import { __extends, __rest, __assign } from 'tslib';
import * as React from 'react';
import { useLocalization } from '@shared-ui/localization-context';
import { UitkIcon, UitkIconSize } from 'uitk-react-icons';
import { classNames, analyticsTracker } from 'uitk-react-utils';
import styles from './uitk-input.css';
var getClassNameList = classNames.bind(styles);
var FauxInput = /** @class */function (_super) {
  __extends(FauxInput, _super);
  function FauxInput(props) {
    var _this = _super.call(this, props) || this;
    _this.state = {
      mounted: false
    };
    _this.handleClear = _this.handleClear.bind(_this);
    return _this;
  }
  FauxInput.prototype.componentDidMount = function () {
    this.setState({
      mounted: true
    });
  };
  FauxInput.prototype.handleClear = function () {
    var handleClear = this.props.handleClear;
    if (typeof handleClear === 'function') {
      handleClear();
    }
  };
  FauxInput.prototype.render = function () {
    var mounted = this.state.mounted;
    var _a = this.props,
      className = _a.className,
      domRef = _a.domRef,
      children = _a.children,
      analytics = _a.analytics,
      hasClearButton = _a.hasClearButton,
      label = _a.label,
      l10n = _a.l10n,
      attrs = __rest(_a, ["className", "domRef", "children", "analytics", "hasClearButton", "label", "l10n"]);
    var showClearButton = mounted && hasClearButton && children;
    // Dummy button is needed to re-render the faux input especially on Firefox for cases where clear button is not required
    var showDummyButton = mounted && !hasClearButton && children;
    var cssClassNames = getClassNameList('uitk-faux-input', className);
    var iconTitle = [l10n.formatText('clear'), label].join(' ');
    if (attrs.handleClear) {
      delete attrs.handleClear;
    }
    return React.createElement(React.Fragment, null, React.createElement("button", __assign({}, attrs, {
      type: "button",
      className: cssClassNames,
      ref: domRef,
      onClickCapture: analytics && analyticsTracker.bind(this, analytics)
    }), children), showDummyButton && React.createElement("button", {
      className: getClassNameList('is-visually-hidden'),
      type: "button",
      "aria-hidden": "true",
      tabIndex: -1
    }), showClearButton && React.createElement("button", {
      className: getClassNameList('uitk-clear-button', 'uitk-input-cta'),
      type: "button",
      onClick: this.handleClear
    }, React.createElement(UitkIcon, {
      name: "cancel",
      size: UitkIconSize.SMALL,
      id: "faux-input-clear-button",
      title: iconTitle
    })));
  };
  return FauxInput;
}(React.Component);
var UitkFauxInput = function (props) {
  var l10n = useLocalization();
  return React.createElement(FauxInput, __assign({
    l10n: l10n
  }, props));
};
export { UitkFauxInput };